import { SetupAuth } from "../../client";

export interface UserRow {
  id: number;
  slug: string;
  googleEmail: string;
  googleName: string | null;
  googlePicture: string | null;
  clientName: string | null;
  inForce: boolean;
  role: string;
  lastLoginAt: string;
  createdAt: string;
}

export async function fetchUsers(token: string): Promise<UserRow[]> {
  const api = SetupAuth(token);
  const { data } = await api.get<{ status: number; users?: UserRow[]; error?: string }>("/users");
  if (data.status !== 200 || !data.users) throw new Error(data.error || "Erro ao buscar usuários");
  return data.users;
}

export async function setUserRole(
  token: string,
  payload: { email: string; role: string }
): Promise<void> {
  const api = SetupAuth(token);
  const { data } = await api.put<{ status: number; error?: string }>("/users/set-role", payload);
  if (data.status !== 200) throw new Error(data.error || "Erro ao atualizar role");
}
